<div *ngIf="loading"
     class="preloader d-flex flex-column  justify-content-center align-items-center position-fixed ">
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
  <ng-container *ngIf="text">
    {{text}}
  </ng-container>
</div>
